module.exports = __webpack_public_path__ + "img/undraw_navigator_a479.e090b6e1.svg";